module.exports = function() {
  return new Worker(__webpack_public_path__ + "cfa839c84f850da09663.worker.js");
};